/* if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
*/
if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      this.initMobileAccordion();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }

    initMobileAccordion() {
      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      if (!isMobile) return;

      const items = this.querySelectorAll(".m-accordion-item");

      items.forEach((item, index) => {
        const header = item.querySelector(".m-accordion-header");

        header.addEventListener("click", () => {
          const isOpen = item.classList.contains("is-open");

          // Close all
          items.forEach(i => i.classList.remove("is-open"));

          // Toggle current
          if (!isOpen) {
            item.classList.add("is-open");
          }
        });
      });

      // Optional: open first by default (matches your setting behavior)
      if (items.length) {
        items[0].classList.add("is-open");
      }
    }
  }

  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
